/* eslint-disable */
require('./1-st-assessment')
require('./accept-active')
require('./accept-kit')
require('./add')
require('./arrow-down-old')
require('./arrow-up')
require('./assign-kit')
require('./badge')
require('./bolt')
require('./calendar')
require('./check-strong')
require('./check')
require('./chevron-down')
require('./circle-alert')
require('./circle-check')
require('./circle-info')
require('./clinical-records')
require('./close-strong')
require('./close')
require('./copy')
require('./delete')
require('./delivered')
require('./download')
require('./edit-outlined')
require('./edit')
require('./exclude')
require('./external-link')
require('./forms')
require('./heart')
require('./hide-password')
require('./image')
require('./left-arrow')
require('./lock')
require('./login')
require('./logout')
require('./mail')
require('./maintenance')
require('./member-profile')
require('./menu')
require('./message')
require('./minus')
require('./notes')
require('./onboarding-profile')
require('./options')
require('./order-kit')
require('./out')
require('./phone')
require('./photo-camera')
require('./pin-map')
require('./power-on-off')
require('./prescription-results')
require('./prescription')
require('./prescriptions')
require('./profile')
require('./rate-star-filled')
require('./rate-star')
require('./reschedule')
require('./results-charts')
require('./retry')
require('./right-arrow')
require('./save')
require('./schedule')
require('./search')
require('./send')
require('./show-password')
require('./spinner')
require('./star-filled')
require('./star')
require('./sword-arrow-down')
require('./sword-arrow-up')
require('./target-arrow')
require('./therapist')
require('./tracking')
require('./transfer')
require('./unlock')
require('./user')
require('./video-call-assessment')
require('./video')
require('./warning')
require('./world')
